import { render, staticRenderFns } from "./PainelAutoeficacia.vue?vue&type=template&id=56613bd7&scoped=true&"
import script from "./PainelAutoeficacia.vue?vue&type=script&lang=js&"
export * from "./PainelAutoeficacia.vue?vue&type=script&lang=js&"
import style0 from "./PainelAutoeficacia.vue?vue&type=style&index=0&id=56613bd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56613bd7",
  null
  
)

export default component.exports